module.exports = __webpack_public_path__ + "media/images/common/ico-btn-notice-off-58dce13c5e6a2fe77778d143d5a9df3a.svg";